import { gql } from '@apollo/client';

// Query to get inquiries with filtering and pagination
export const GET_INQUIRIES = gql`
  query GetInquiries($limit: Int, $nextToken: String, $status: InquiryStatus) {
    listInquiries(limit: $limit, nextToken: $nextToken, status: $status) {
      items {
        id
        firstName
        lastName
        email
        phoneNumber
        incidentType
        incidentDate
        incidentLocation
        description
        injuryTypes
        injurySeverity
        source
        status
        leadScore
        assignedTo
        assignedToName
        caseId
        userId
        createdAt
        updatedAt
        activityLog {
          id
          activityType
          performedByName
          timestamp
          details
        }
      }
      nextToken
    }
  }
`;

// Legacy query name for backward compatibility
export const LIST_INQUIRIES = GET_INQUIRIES;

// Query to get a single inquiry
export const GET_INQUIRY = gql`
  query GetInquiry($id: ID!) {
    getInquiry(id: $id) {
      id
      firstName
      lastName
      email
      phoneNumber
      preferredContactMethod
      bestTimeToContact
      zipCode
      address {
        street1
        street2
        city
        state
        zipCode
        country
      }
      incidentType
      incidentDate
      incidentTime
      incidentLocation
      weatherConditions
      description
      injuryTypes
      injurySeverity
      medicalAttentionSought
      medicalAttentionTiming
      treatmentLocation
      ongoingTreatment
      hasHealthInsurance
      policeReportFiled
      policeReportNumber
      atFault
      otherPartyInsured
      otherPartyInsurance
      contactedByInsurance
      hasAttorney
      claimOrLawsuitFiled
      estimatedDamages
      hasPhotosVideos
      hasWitnesses
      witnessInfo
      referralSource
      additionalComments
      
      # Email-specific fields
      source
      referralTransactionNumber
      brokerCaseManager
      brokerCaseManagerEmail
      dateOfBirth
      spokenLanguage
      employer
      emergencyContactName
      emergencyContactPhone
      documentsUploaded
      crossStreets
      injuryDescription
      treatmentDescription
      lawsuitFiledDate
      tdRequestReason
      isPostConversion
      extractionMetadata
      referralLink
      
      # AI Processing Fields
      aiProcessingMetadata
      dynamicInquiryData
      
      status
      leadScore
      assignedTo
      assignedToName
      assignedAt
      lastContactedAt
      lastContactMethod
      clientLastRespondedAt
      followUpDate
      notes
      createdAt
      updatedAt
      activityLog {
        id
        activityType
        performedBy
        performedByName
        timestamp
        details
        metadata
      }
      attachments {
        id
        fileName
        fileType
        fileSize
        s3Key
        uploadedAt
        description
      }
    }
  }
`;

// Mutation to create a new inquiry
export const CREATE_INQUIRY = gql`
  mutation CreateInquiry($input: CreateInquiryInput!) {
    createInquiry(input: $input) {
      id
      firstName
      lastName
      email
      phoneNumber
      incidentType
      incidentDate
      description
      status
      leadScore
      createdAt
      updatedAt
    }
  }
`;


// Mutation to update inquiry status
export const UPDATE_INQUIRY_STATUS = gql`
  mutation UpdateInquiryStatus($id: ID!, $status: InquiryStatus!) {
    updateInquiryStatus(id: $id, status: $status) {
      id
      status
      updatedAt
    }
  }
`;



// Mutation to convert inquiry to case
export const CONVERT_INQUIRY_TO_CASE = gql`
  mutation ConvertInquiryToCase($id: ID!, $assignedAttorneyId: ID, $assignedCaseManagerId: ID) {
    convertInquiryToCase(id: $id, assignedAttorneyId: $assignedAttorneyId, assignedCaseManagerId: $assignedCaseManagerId) {
      id
      caseNumber
      assignedAttorneyId
      assignedCaseManagerId
      status
      caseType
      description
      createdAt
      updatedAt
    }
  }
`;

// Mutation to log inquiry activity
export const LOG_INQUIRY_ACTIVITY = gql`
  mutation LogInquiryActivity($input: LogInquiryActivityInput!) {
    logInquiryActivity(input: $input) {
      id
      inquiryId
      activityType
      performedBy
      performedByName
      timestamp
      details
      metadata
    }
  }
`;

// Mutation to update inquiry tracking
export const UPDATE_INQUIRY_TRACKING = gql`
  mutation UpdateInquiryTracking($id: ID!, $input: UpdateInquiryTrackingInput!) {
    updateInquiryTracking(id: $id, input: $input) {
      id
      lastContactedAt
      lastContactMethod
      clientLastRespondedAt
      followUpDate
      notes
      assignedTo
      updatedAt
    }
  }
`;

// Query to get inquiry metrics - Note: This query is not implemented in current schema
// export const GET_INQUIRY_METRICS = gql`
//   query GetInquiryMetrics($startDate: AWSDateTime, $endDate: AWSDateTime) {
//     inquiryMetrics(startDate: $startDate, endDate: $endDate) {
//       totalInquiries
//       newInquiries
//       qualifiedInquiries
//       convertedInquiries
//       conversionRate
//       averageLeadScore
//     }
//   }
// `;